import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportComponentBase, ReportPreviewItem } from '../../../FW/core/report-component-base';
import { ReportService } from '../../../FW/services/reports/report.service';


@Component({
  selector: 'audit-changes-report',
  templateUrl: './audit-changes-report.component.html',
  styleUrls: ['../../report.component.scss'],
  encapsulation: ViewEncapsulation.None // Add this line
})

export class AuditChangesReportComponent extends ReportComponentBase implements OnInit {
    reportOrientation: string = 'landscape';

  constructor(public dialogRef: MatDialogRef<AuditChangesReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReportPreviewItem,
  public reportService: ReportService) {
    super(dialogRef, data, reportService);

    //Set orientation; portrait | landscape
    this.reportOrientation = 'landscape';
  }

  ngOnInit() {
    super.ngOnInit();
    this.reportOrientation = 'landscape';
  }

}
